<div class="tab-pane" role="tabpanel" id="tipoprop">
    <fieldset id="agregar_tipoprop" class="">
        <div class="step_section">
            <div class="row" id="row">

                <div class="col-md-12" id="content">
                    <div class="alert alert-danger" role="alert" id="tp_find_alert" name="tp_find_alert" hidden>
                        <i class="fa fa-exclamation-triangle fa-2x" aria-hidden="true"></i>
                        <span id="tp_dir_message"></span>
                    </div>

                    <div class="form-horizontal">

                        <div class="form-group" align="left">
                            <div class="col-sm-2">
                                <label for="tipo_prop">Tipo de Propiedad:</label>
                            </div>
                            <div class="col-sm-2" class="inline" style="font-size: 13px">
                                <!-- <form [formGroup]="form"> -->
                                <div class="col-md-3">
                                    <mat-checkbox (change)="add_tipo_propiedad()" [(ngModel)]="tipos.urbano" name="optchk1" value="SI">URBANO</mat-checkbox>
                                </div>
                                <div class="col-md-3">
                                    <mat-checkbox (change)="add_tipo_propiedad()" [(ngModel)]="tipos.rural" name="optchk2" value="SI">RURAL</mat-checkbox>
                                </div>

                                <!--<div class="col-sm-3">
                                    <label class="checkbox-inline"><input id="optchk" [(ngModel)]="tipos.uno" (change)="add_tipo_propiedad()" name="optchk1" type="checkbox" value="1"/>URBANO</label>
                                </div>
                                <div class="col-sm-2">
                                    <label class="checkbox-inline"><input id="optchk"  [(ngModel)]="tipos.dos" (change)="add_tipo_propiedad()" name="optchk2" type="checkbox" value="2">RURAL</label>
                                </div>-->

                                <!-- <mat-radio-group formControlName="options" (change)="add_tipo_propiedad($event)">
                                        <mat-radio-button name="tpradio" style="padding-left: 15px; padding-right: 20px" labelPosition='after' *ngFor="let tipo of tipos; let i = index" [value]="(i+1)">{{tipo}}</mat-radio-button>
                                    </mat-radio-group> -->
                                <!-- </form> -->


                            </div>
                            <div class="col-sm-6"></div>
                        </div>
                    </div>
                    <br>
                </div>

            </div>
        </div>
    </fieldset>
</div>
<div class="separator"></div>